import type { PageSettings } from '@common/types/page-settings.type';
import type { PageSettingsState } from './page-settings.reducer';
import type { WebsiteState } from '../website-feature.reducer';

import { createSelector } from '@ngrx/store';

import { WEBSITE_PAGE_SETTINGS_FEATURE_KEY } from './page-settings.reducer';
import { websiteState } from '../website-state.selectors';

export const selectSettingsState = createSelector(
    websiteState,
    (state: WebsiteState): PageSettingsState => state[WEBSITE_PAGE_SETTINGS_FEATURE_KEY]
);

export const selectPageSettings = (pageId: number | string) =>
    createSelector(
        selectSettingsState,
        (state: PageSettingsState): PageSettings => state?.settings[pageId.toString()] ?? null
    );
